import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  href = 'https://aprendeemprendearg.com/checkouts/cn/hWN8vkuSLIFaFVreWbpAfIpe/es-ar?_r=AQABpD3bhSDa5Y7x7esKCWyapvvndv3TTinvI6GShoR-cLs&preview_theme_id=182034956655'
}: CTAButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`
        group relative overflow-hidden rounded-full 
        bg-gradient-to-r from-[#C5A55A] via-[#D4B96A] to-[#C5A55A] 
        bg-[length:200%_auto] transition-all duration-500 hover:bg-right
        px-8 py-4 font-bold text-[#1E1B19] shadow-lg shadow-[#C5A55A]/20
        transform hover:-translate-y-0.5 active:translate-y-0
        flex items-center justify-center gap-2 no-underline
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-1">
      <span className="relative z-10 tracking-wide text-lg uppercase" data-id="element-2">
        {children}
      </span>
      <ArrowRight className="w-5 h-5 relative z-10 transition-transform group-hover:translate-x-1" data-id="element-3" />

      {/* Shine effect overlay */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/25 to-transparent z-0" data-id="element-4" />
    </a>;
}